import styled from "styled-components";

import {
  DefaultGroupTableWrapper,
  DefaultTableListWrapper,
} from "@FillInTableContainer/shared/styles/groupTable.style";

export const GroupTableWrapper = styled(DefaultGroupTableWrapper)`
  background-color: #f8f9fa;
  border-radius: 0.8rem;
`;

export const TableCreatorTableListWrapper = styled(DefaultTableListWrapper)``;
